export const CTA_SECTION_ID = 'page-cta-section';
